// extracted by mini-css-extract-plugin
export default {"message":"message_message__ikTS6","inner":"message_inner__rHm8s"};